import { FC } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface ActionButtonProps {
  onPrimaryButtonClick: () => void
}

const ActionButton: FC<ActionButtonProps> = ({ onPrimaryButtonClick }) => {
  return (
    <Box flexDirection="row" justifyContent="flexStart" gap="s8">
      <Button onClick={onPrimaryButtonClick}>
        {i18n.t('project_management.landing_page.button.start')}
      </Button>
    </Box>
  )
}

export default ActionButton
